export const NONE = 'None';
export const CHILD = 'Child';
export const BOTH = 'Child and adult';

export const orthodontiaCoverage = [
    {display: 'Please select', value: ''},
    {display: NONE, value: NONE},
    {display: CHILD, value: CHILD},
    {display: BOTH, value: BOTH}
];